/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 19.08.2016.
 */

import Favorites from './reducer-favorites';

export default Favorites;



// WEBPACK FOOTER //
// ./src/reducers/favorites/index.js